
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/profile/vouchers",
      function () {
        return require("private-next-pages/[lang]/profile/vouchers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/profile/vouchers"])
      });
    }
  